/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ViewState = {
    DONE: 'DONE',
    PARTIALLY_DONE: 'PARTIALLY_DONE'
} as const;
export type ViewState = typeof ViewState[keyof typeof ViewState];


export function instanceOfViewState(value: any): boolean {
    for (const key in ViewState) {
        if (Object.prototype.hasOwnProperty.call(ViewState, key)) {
            if (ViewState[key as keyof typeof ViewState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ViewStateFromJSON(json: any): ViewState {
    return ViewStateFromJSONTyped(json, false);
}

export function ViewStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewState {
    return json as ViewState;
}

export function ViewStateToJSON(value?: ViewState | null): any {
    return value as any;
}

export function ViewStateToJSONTyped(value: any, ignoreDiscriminator: boolean): ViewState {
    return value as ViewState;
}

